import React, {
  useState,
  useCallback,
  useMemo,
  useEffect,
} from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import useWizardStore from '@zs/useWizardStore';
import { ImageBrowser } from '@svg/ImageBrowser';

interface FixationOptionProps {
  eye: 'OD' | 'OS';
  onBinoc: (value: boolean | null) => void;
}
export const FixationOption = ({
  eye,
  onBinoc,
}: FixationOptionProps): JSX.Element => {
  const cacheLoaded = useWizardStore(state => state.cacheLoaded);
  const binocularFixation = useWizardStore(state => state.binocularFixation);
  const setBinocularFixation = useWizardStore(state => state.setBinocularFixation);


  const handleSelect_Change = useCallback((e) => {
    const bf = e.target.value.length < 1 ? null : (e.target.value === 'true');
    setBinocularFixation(bf);
    onBinoc(bf);
  }, [setBinocularFixation, onBinoc]);


  if (!cacheLoaded)
    return <div>uninitialized</div>

  let selected = '';
  if (binocularFixation != null)
    selected = binocularFixation ? 'true' : 'false';


  return contain(
    <>
      <div className='flex flex-col gap-2'>
        <div>{Q_BF}</div>
        <div className='flex flex-row items-center gap-2'>
          <select
            value={selected}
            onChange={handleSelect_Change}
            className='bg-blue-100 p-2 rounded-md'
          >
            <option value='' className='text-gray-600'>
              Select...
            </option>
            <option value='false'>Yes</option>
            <option value='true'>No</option>
          </select>
          <div className='text-sm'>
            {binocularFixation == null
              ? ''
              : binocularFixation
              ? DESC_BF_1
              : DESC_BF_0}
          </div>
        </div>
      </div>
      <ImageBrowser
        eye={eye}
        alignRED='L'
        alignScroll='L'
      />
    </>
  );
}


function contain(children: React.ReactNode): JSX.Element {
  return (<div className='flex flex-col gap-2 justify-evenly items-center bg-gray-100 p-2 rounded-md min-h-[10rem]'>
    {children}
  </div>);
}


const Q_BF = <span>Does the Non-Study Eye (shown) appear able to fixate consistently using either fovea or PRL?</span>;
const DESC_BF_0 = <span>All tests will have a <b>monocular</b> fixation task.</span>;
const DESC_BF_1 = <span>All tests will have a <b>binocular</b> fixation task.</span>;
